module.exports = __webpack_public_path__ + "img/burrito_pollo.259bdc11.jpeg";